import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";

import styles from "./MonitoringLevels.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Preparations.messages";

type MonitoringLevelsModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const MonitoringLevelsModal: React.FC<MonitoringLevelsModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        <div className={styles.content}>
          <h2 className={styles.title}>{formatMessage(messages.monitoringLevelsModalTitle)}</h2>
          <p className={styles.description}>{formatMessage(messages.monitoringLevelsModalDescription)}</p>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/3.png`}
            alt="feature-comparison"
          />
        </div>
      </div>
    </ui.Modal>
  );
};
